import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import './TargetLanguage.css';

const languages = [
    {
        code: 'italian',
        flag: '🇮🇹',
        name: 'Italian',
        native: 'Italiano',
        speakers: '85 million speakers',
        tags: ['CILS', 'CELI', 'PLIDA'],
    },
    {
        code: 'spanish',
        flag: '🇪🇸',
        name: 'Spanish',
        native: 'Español',
        speakers: '500 million speakers',
        tags: ['DELE', 'SIELE'],
    },
    {
        code: 'french',
        flag: '🇫🇷',
        name: 'French',
        native: 'Français',
        speakers: '300 million speakers',
        tags: ['DELF', 'DALF'],
    },
    {
        code: 'english',
        flag: '🇬🇧',
        name: 'English',
        native: 'English',
        speakers: '1.5 billion speakers',
        tags: ['IELTS', 'Cambridge'],
    },
];

function TargetLanguage() {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [selected, setSelected] = useState(null);
    const spokenLanguage = localStorage.getItem('vozoly_ui_language') || '';
    const filteredLanguages = languages.filter(
        l => l.name.toLowerCase() !== spokenLanguage.toLowerCase()
    );

    const handleConfirm = () => {
        if (selected) {
            localStorage.setItem('vozoly_target_language', selected);
            localStorage.setItem('vozoly_onboarding_step', 'goal');
            navigate('/onboarding/goal');
        }
    };

    return (
        <div className="tl-screen">

            <div className="tl-top">
                <button className="tl-back" onClick={() => navigate('/language')}>←</button>
                <div className="tl-step">{t('onboarding.targetLanguage.step')}</div>
            </div>

            <div className="tl-content">
                <div className="tl-heading">{t('onboarding.targetLanguage.heading')}</div>
                <div className="tl-subheading">
                    {t('onboarding.targetLanguage.subheading')}
                </div>

                <div className="tl-grid">
                    {filteredLanguages.map(lang => (
                        <div
                            key={lang.code}
                            className={`tl-card ${selected === lang.code ? 'selected' : ''}`}
                            onClick={() => setSelected(lang.code)}
                        >
                            <div className="tl-card-top">
                                <div className="tl-flag">{lang.flag}</div>
                                {selected === lang.code && <div className="tl-check">✓</div>}
                            </div>
                            <div className="tl-name">{lang.name}</div>
                            <div className="tl-native">{lang.native}</div>
                            <div className="tl-speakers">{lang.speakers.replace('speakers', t('onboarding.targetLanguage.speakers'))}</div>
                            <div className="tl-tags">
                                {lang.tags.map(tag => (
                                    <span key={tag} className="tl-tag">{tag}</span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="tl-note">
                    {t('onboarding.targetLanguage.examNote')}
                </div>
            </div>

            <div className="tl-footer">
                <button
                    className="tl-confirm-btn"
                    disabled={!selected}
                    onClick={handleConfirm}
                >
                    {selected
                        ? `${t('onboarding.targetLanguage.startLearning')} ${languages.find(l => l.code === selected)?.name} →`
                        : t('onboarding.targetLanguage.chooseLanguage')}
                </button>
            </div>

        </div>
    );
}

export default TargetLanguage;